import React from 'react';
import { FormHelperText, Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import { AdminFieldLabel } from '@/admin/shared/AdminFieldLabel';
import { ResponsiveAutocomplete } from '@/components/selects/ResponsiveAutocomplete';
import { useListCountriesQuery } from '../../api/brokerGroupsApi';
import { BROKER_GROUP_FIELD_LABELS } from '../brokerGroupFormValues';

/** The broker group's state: optional, and only shown for a country with states (Australia). */
export const BrokerGroupStateField = () => {
	const { values, touched, errors, setFieldValue } = useFormikContext();
	const { data: countries = {} } = useListCountriesQuery();
	const states = countries[values.country]?.states ?? [];
	const error = touched.state && errors.state;

	if (!states.length) {
		return null;
	}

	return (
		<Grid size={{ xs: 12, sm: 4 }}>
			<AdminFieldLabel name='state'>{BROKER_GROUP_FIELD_LABELS.state}</AdminFieldLabel>
			<ResponsiveAutocomplete
				options={states}
				value={values.state}
				onChange={(state) => setFieldValue('state', state ?? null)}
				error={Boolean(error)}
			/>
			{error && <FormHelperText error>{error}</FormHelperText>}
		</Grid>
	);
};
